import { Dismiss, DismissSmall } from '@wix/wix-ui-icons-common';
import React, { FC, MouseEventHandler } from 'react';

import { classNames } from '../../../../util';
import s from './CloseButton.scss';

interface Props {
  middle?: boolean;
  className?: string;
  dataHook?: string;
  onClick?: MouseEventHandler;
}

export const CloseButton: FC<Props> = ({ className, onClick, dataHook = 'close', middle = false }) => (
  <button
    type="button"
    tabIndex={0}
    className={classNames([s.x, className])}
    onClick={onClick}
    aria-label="close"
    data-hook={dataHook}
  >
    {middle ? <Dismiss /> : <DismissSmall />}
  </button>
);
